module.exports = __webpack_public_path__ + "img/part_c_img@2x.e41739bb.png";